import { formatTimeShort } from "@/lib/calendar-utils";

interface CurrentTimeLineProps {
  position: number;
  currentTime: Date;
}

export function CurrentTimeLine({
  position,
  currentTime,
}: CurrentTimeLineProps) {
  return (
    <div
      className="absolute left-0 right-0 z-10 pointer-events-none"
      style={{ top: `${position}px` }}
    >
      {/* Time label on left */}
      <div className="absolute -left-16 md:-left-20 -top-2.5 bg-red-500 text-white text-xs px-1.5 py-0.5 rounded font-medium">
        {formatTimeShort(currentTime)}
      </div>
      {/* Circle indicator */}
      <div className="absolute -left-1.5 -top-1.5 w-3 h-3 bg-red-500 rounded-full" />
      {/* Line */}
      <div className="h-0.5 bg-red-500/70" />
    </div>
  );
}
